var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSectionSiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.33333V5.83333C17.5 6.33333 17.1667 6.66667 16.6667 6.66667C16.1667 6.66667 15.8333 6.33333 15.8333 5.83333V4.16667H10.8333V15.8333H12.5C13 15.8333 13.3333 16.1667 13.3333 16.6667C13.3333 17.1667 13 17.5 12.5 17.5H7.5C7 17.5 6.66667 17.1667 6.66667 16.6667C6.66667 16.1667 7 15.8333 7.5 15.8333H9.16667V4.16667H4.16667V5.83333C4.16667 6.33333 3.83333 6.66667 3.33333 6.66667C2.83333 6.66667 2.5 6.33333 2.5 5.83333V3.33333C2.5 2.83333 2.83333 2.5 3.33333 2.5H16.6667C17.1667 2.5 17.5 2.83333 17.5 3.33333Z",
    fill: "#6E6B7B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionSiteIcon);
export default __webpack_public_path__ + "static/media/sectionSiteIcon.b7e2a7c545c74c926f697af94e694494.svg";
export { ForwardRef as ReactComponent };